import { makeAutoObservable } from "mobx";

const STORAGE_KEY = "hp_sign_in";

/**
 * Sign-in is hidden until Postmark has approved the account to mail every address.
 * `VITE_SIGN_IN=true` turns it on for everyone. Until then `?signin=1` turns it on in
 * this browser (remembered), and `?signin=0` turns it off again, so it can be tested in production.
 */
export const readSignInEnabled = (): boolean => {
    if (import.meta.env.VITE_SIGN_IN === "true") return true;
    if (typeof window === "undefined") return false;

    try {
        const requested = new URLSearchParams(window.location.search).get("signin");
        if (requested === "1") localStorage.setItem(STORAGE_KEY, "1");
        if (requested === "0") localStorage.removeItem(STORAGE_KEY);
        return localStorage.getItem(STORAGE_KEY) === "1";
    } catch {
        // Storage can be blocked; sign-in then stays hidden
        return false;
    }
};

export class AppStore {
    showSignIn = false;
    signInEnabled = readSignInEnabled();

    constructor() {
        makeAutoObservable(this);
    }

    setShowSignIn(show: boolean) {
        this.showSignIn = show;
    }
}
